import { Grid, Typography } from '@mui/material'
import { VibioPageMobile } from './VibioPageMobile'
import JoinVibioCard from '../../components/videopage/profile/JoinVibioCard'

const styles = {
    container: {
        height: '100dvh',
    },
    leftColumn: {
        m: 0,
        p: 1,
    },
    centerColumn: {
        m: 0,
        p: 0,
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.77)',
    },
    rightColumn: {
        mb: 1,
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        fontWeight: 800,
        fontFamily: 'inherit',
        fontSize: '5.6rem',
        textAlign: 'center',
        color: 'primary.main',
    },
    subtitle: {
        fontWeight: 600,
        fontFamily: 'inherit',
        textAlign: 'center',
        color: 'text.gray',
    },
    joinCardWrapper: {
        alignSelf: 'center',
    },
}

export default function VibioPageWeb({ videoSrc, socials, linkButtons, userData, theme, onLinkClick }) {
    return (
        <Grid container spacing={0} sx={styles.container}>
            <Grid item xs={4.5} sx={styles.leftColumn} />

            <Grid item xs={3} sx={styles.centerColumn}>
                <VibioPageMobile
                    videoSrc={videoSrc}
                    socials={socials}
                    linkButtons={linkButtons}
                    userData={userData}
                    theme={theme}
                    onLinkClick={onLinkClick}
                />
            </Grid>

            <Grid item xs={4.5} sx={styles.rightColumn}>
                <Typography variant="h1" sx={styles.title}>
                    Vibio
                </Typography>
                <Typography variant="subtitle1" sx={styles.subtitle}>
                    designed to tell your story
                </Typography>
                {userData?.tier === 'LIGHT' && (
                    <div style={styles.joinCardWrapper}>
                        <JoinVibioCard username={userData.username} />
                    </div>
                )}
            </Grid>
        </Grid>
    )
}
